// @flow

import * as React from 'react';
import { NotFound as NotFoundBox } from 'gandi.react-static-pages';

import Layout from './Layout';

export default function NotFound(): React.Element<typeof Layout> {
  return (
    <Layout mainWrapper={false}>
      <NotFoundBox />
    </Layout>
  );
}
